import React from "react";
import { FastField } from "formik";
import Radio from "@mui/material/Radio";
import RadioGroupMui from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const onChangeField = (field, onChange = null) => (event) => {
  field.onChange(event)
  if (onChange) { onChange(field.name, event.target.value) }
}

const DefaultRadioComponent = ({ option, labelPlacement, disabled, size }) =>
  <FormControlLabel
    sx={{ mb: 0 }}
    labelPlacement={labelPlacement}
    value={option[0]}
    control={<Radio size={size} sx={{ mb: 0 }} disabled={disabled} color="primary" />}
    label={<Typography color="textSecondary" variant="body2">{option[1]}</Typography>}
  />

const DefaultRadioComponentWrap = ({ row, label, name, disabled, onChange, children }) =>
  <FastField name={name}>
    {({ field, form, meta }) =>
      <RadioGroupMui
        disabled={disabled}
        row={row}
        aria-label={label}
        name={name}
        {...field}
        onChange={onChangeField(field, onChange)}
        value={field.value || undefined}
      >
        {children}
      </RadioGroupMui>
    }
  </FastField>

const RadioGroup = ({
  label,
  labelPlacement = "end",
  size = "medium",
  row = false,
  options,
  control,
  component,
  componentWrap,
  className,
  name,
  disabled,
  onChange,
}) => {
  const withoutRadioLabel = !!component;
  const RadioComponent = component || DefaultRadioComponent;
  const RadioComponentWrap = componentWrap || DefaultRadioComponentWrap;

  return (
    <FormControl className={className} fullWidth>
      {label && <Box mb={size == "small" ? 0 : 2}>
        <FormLabel component="legend">{label}</FormLabel>
      </Box>}

      <RadioComponentWrap
        disabled={disabled}
        row={row}
        label={label}
        name={name}
        onChange={onChange}
      >
        {options.map((option) => (
          <Box key={option[0]} mb={0}>
            <RadioComponent
              size={size}
              disabled={disabled}
              name={name}
              option={option}
              withoutRadioLabel={withoutRadioLabel}
              labelPlacement={labelPlacement}
            />
          </Box>
        ))}
      </RadioComponentWrap>
    </FormControl>
  );
};

export default React.memo(RadioGroup);
